<template>
  <div class="page" style="position: relative"></div>
</template>

<script type="text/ecmascript-6">
export default {
  name: "web_0",
  data() {
    order_number: "(NOT FOUND)"
  },
  methods: {},
  mounted() {
    this.order_number = this.$route.params.order_number;
    window.open("/mst/product_detail.html?catalog_number=" + this.order_number, "_self");
  },
  created() {}
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/products.vue